import { createSlice, Slice, PayloadAction } from '@reduxjs/toolkit';
import { informationDefaultValue as defaultValue, InformationType, SnackBarStatuses } from 'learning-panel-components';

/* eslint-disable no-param-reassign */
export const informationSlice: Slice = createSlice({
    name: 'information',
    initialState: defaultValue,
    reducers: {
        showAlert: (
            state,
            action: PayloadAction<{
                value: string;
                status: keyof typeof SnackBarStatuses;
                isAdmin?: boolean;
                title?: string;
                inIframe?: boolean;
            }>
        ): void => {
            state.message = action.payload.value;
            state.title = action.payload.title;
            state.variant = action.payload.status;
            state.isOpen = true;
            state.isInIframe = action.payload.inIframe || false;
            state.isAdmin = action.payload.isAdmin || false;
        },
        onClose: (state): void => {
            state.isOpen = false;
        },
        resetAlert: (state, _action: PayloadAction<void>): void => {
            state.message = defaultValue.message;
            state.variant = defaultValue.variant;
            state.isOpen = defaultValue.isOpen;
            state.isInIframe = defaultValue.isInIframe;
            state.isAdmin = false;
            state.title = '';
        }
    }
});

export const { showAlert, onClose, resetAlert } = informationSlice.actions;

type informationSliceState = { information: InformationType };
export const selectVariant = (state: informationSliceState): keyof typeof SnackBarStatuses => state.information.variant;
export const selectMessage = (state: informationSliceState): string => state.information.message;
export const selectIsOpen = (state: informationSliceState): boolean => state.information.isOpen;
export const selectIsInIframe = (state: informationSliceState): boolean => state.information.isInIframe;
export const selectIsAdmin = (state: informationSliceState): boolean | undefined => state.information.isAdmin;
export const selectTitle = (state: informationSliceState): string | undefined => state.information.title;

export default informationSlice.reducer;
